<template>
    <div>
        <gofix-card title="Line Items" class="mb-0" fullContent>
            <gofix-default-table
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="newItem"
                @row-click="rowClick"
                @delete-items="deleteItems"
                ref="gofixTable">
                <template slot="gofix_table:unit_price" slot-scope="row">
                    {{ row.item.unit_price  | formatMoney }}
                </template>
                <template slot="gofix_table:total_price" slot-scope="row">
                    {{ row.item.total_price  | formatMoney }}
                </template>
                <template slot="gofix_table:bottom-row" slot-scope="row">
                    <td v-for="(field, i) in row.data.fields" :key="i" :class="field.tdClass || ''">
                        <div v-if="field.key === 'unit_price'" class="value font-weight-bold">Total</div>
                        <div v-if="field.key === 'total_price'" class="value font-weight-bold">{{ Item && Item.total_net_amount ? Item.total_net_amount : null | formatMoney }}</div>
                    </td>
                </template>
            </gofix-default-table>
        </gofix-card>
        <b-modal 
            :no-close-on-backdrop="true" 
            :title="modals.line.title" 
            id="modal-PartReplacement"
            hide-footer 
            :centered="true" 
            size="xl"
            @shown="showModal"
            v-model="modals.line.open">
            <div :class="{'disabled-block run-loading': modals.line.loadingModal}">
                <template v-if="modals.line.data.line_items.length">
                    <template v-for="(item, index) in modals.line.data.line_items">
                        <div :key="index">
                            <b-row>
                                <b-col md="12" v-if="modals.line.isNew">
                                    <div class="d-flex align-items-center justify-content-between action actionFloat actionFloat__extra d-flex font-weight-bold">
                                        <h4>
                                            <b-badge variant="secondary">Item #{{index+1}}</b-badge>
                                            <!-- <gofix-button class="mb-0 gofixButtonFix" label="Add new item +" outline></gofix-button> -->
                                        </h4>
                                        <div class="pb-1">
                                            <b-button @click="addItem(index)" title="Create" v-b-tooltip.hover>
                                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                                </svg>
                                            </b-button>
                                            <b-button :disabled="modals.line.data.line_items.length == 1" @click="delItem(index)" title="Delete" v-b-tooltip.hover>
                                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                                </svg>
                                            </b-button>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-dropdown
                                        class="fakeTable"
                                        label="Sor Code"
                                        vLabel="sor_code"
                                        :filterable="false"
                                        @search="(search, loading) => {
                                            searchSOR(search, loading, index)
                                        }"
                                        required
                                        v-model="item.sor"
                                        :options="modals.line.sorOptions[`item_${index+1}`] || []">
                                        <template #gofixInput:dropdown:list-header>
                                            <div class="d-table fakeTableHeader">
                                                <div class="d-table-cell cell itemTitle itemCode">Code</div>
                                                <div class="d-table-cell cell itemTitle itemSorGroup">SOR Group</div>
                                                <div class="d-table-cell cell itemTitle itemDescription">Description</div>
                                                <div class="d-table-cell cell itemTitle itemUnitPrice text-right">Unit Price</div>
                                                <div class="d-table-cell cell itemTitle itemUom">UOM</div>
                                            </div>
                                        </template>
                                        <template #gofixInput:dropdown:option="{ sor_code , description_one, description_two, sor_group, unit_of_measurement, unit_price}">
                                            <div class="d-table fakeTableBody">
                                                <div class="d-table-cell cell itemValue itemCode">{{sor_code}}</div>
                                                <div class="d-table-cell cell itemValue itemSorGroup">{{sor_group ? sor_group.description_one : null}}</div>
                                                <div class="d-table-cell cell itemValue itemDescription">
                                                    {{description_one}} <span class="color-red" v-if="description_two"> - {{description_two}}</span>
                                                </div>
                                                <div class="d-table-cell cell itemValue itemUnitPrice text-right">{{ unit_price | formatMoney}}</div>
                                                <div class="d-table-cell cell itemValue itemUom">{{unit_of_measurement}}</div>
                                            </div>
                                        </template>
                                    </gofix-form-dropdown>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="12" class="mb-16">
                                    <gofix-text-field class-label="min-width-105" label="Description" oneline >
                                        <div v-html="$options.filters.showDescription(item.sor)"></div>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row align-v="center">
                                <b-col md="3">
                                    <gofix-text-field class-label="min-width-105" label="Unit Price" oneline>{{ item.sor && item.sor.unit_price ? item.sor.unit_price : null | formatMoney }}</gofix-text-field>
                                </b-col>
                                <b-col md="3">
                                    <gofix-form-input-number 
                                        label="Quantity" 
                                        v-model="item.quantity">
                                    </gofix-form-input-number>
                                </b-col>
                                <b-col md="6">
                                    <gofix-text-field class-label="min-width-105" label="Total Price" oneline>{{ item.sor && item.sor.unit_price && item.quantity ? item.quantity * item.sor.unit_price : null | formatMoney }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <hr v-if="index != (modals.line.data.line_items.length - 1)" class="w-100 mt-5 mb-20" />
                        </div>
                    </template>
                </template>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="save" :disabled="modals.line.loading" noBorder></gofix-button>
                </b-button-group>
            </div>
            
        </b-modal>
    </div>
    <!-- <hr class="w-100 mt-5 mb-20" /> -->
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'defect-report-detail',
        components: {},
        props: {
            is_supplier: {
                type: Boolean,
                default: false
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['lmu_defect_report_item_listing']));
            return {
                tableItems: [],
                tableConfig:{
                    name: "lmu-defect-report-item-listing",
                    controls:{
                        create: true,
                        delete: true,
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc"
                },
                modals: {
                    line: {
                        title: '',
                        open: false,
                        loading: false,
                        data: {
                            line_items: []
                        },
                        sorOptions: {},
                        loadingModal: false,
                        isNew: false,
                    }
                },
                timer: {
                    sor: null,
                    save: null
                }
            }
        },
        computed: {
            ...mapGetters({
                Item: 'LMUApprovalRequestController/item',
                User : 'AuthController/user',
            })
        },
        filters:{
           showDescription(val) {
                let description = '';
                if(val) {
                    description = val.description_one;
                    if(val.description_two) {
                        description += ` - <span class="color-red">${val.description_two}</span>`;
                    }
                }
                return description;
            },
        },
        watch: {
            Item: function(val) {
                if(val && val.status) {
                    this.updateConfigButton(val)
                }
            }
        },
        created() {
            if(this.Item) this.updateConfigButton(this.Item)
        },
        methods: {
            /*-- Get Data --------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.lmu_approval_request_id.value = this.$route.params.id;
                await this.$store.dispatch("LMUApprovalRequestController/getLineItems", tableRequest)
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification("Can not load defect line item", "danger");
                    reject();
                });
            },
            async getListSOR(sftSor = null, index = null){
                if(!this.Item || !this.Item.contract || !this.Item.contract.contract_terms) return
                await this.$store.dispatch( 'v2SorController/searchSorCode',
                [1, 100, '',
                        {
                        contract_term_id: this.Item.contract.contract_terms[0] ? this.Item.contract.contract_terms[0].id : null,
                        is_maintenance: false,
                        search: sftSor,
                    },
                    this.Item ? this.Item.client_contract_id : null
                ])
                .then(response => {
                    let items = response.data.data.items
                    if(index === null) {
                        let arrTmp = {}
                        for(let i = 0; i < this.modals.line.data.line_items.length; i++) {
                            arrTmp[`item_${i+1}`] = items
                        }
                        this.modals.line.sorOptions = Object.assign({}, arrTmp)
                        
                    } else {
                        this.$set(this.modals.line.sorOptions, [`item_${index+1}`], items);
                    }
                    this.modals.line.loadingModal = false
                })
                .catch(err => {
                    this.modals.line.loadingModal = false
                })
            },
            async searchSOR(search, loading, index){
                if(index !== null && this.modals.line.sorOptions[`item_${index+1}`]) this.modals.line.sorOptions[`item_${index+1}`] = []
                loading(true);
                if(this.timer.sor) {
                    clearTimeout(this.timer.sor);
                }
                this.timer.sor = setTimeout(async () => {
                    try {
                        await this.getListSOR(search, index);
                        await loading(false)
                    } catch(e) {
                        console.log(e)
                        loading(false)
                    }
                },300)
            },
            getDefectItem() {
                this.$store.dispatch( 'LMUApprovalRequestController/getItem', this.$route.params.id)
            },

            /*-- Config Button Table --------*/
            async updateConfigButton (val){
                this.tableConfig.controls.create = false
                this.tableConfig.controls.delete = false
                if(this.is_supplier && val.created_by == this.User.id && (val.current_approval_level === -1 || val.current_approval_level === null) && (val.status == 'Draft' || val.status == 'Pending Revision')) {
                    this.tableConfig.controls.create = true;
                    this.tableConfig.controls.delete = true
                }

                this.$nextTick(() => {
                    this.$refs['gofixTable'].updateCreateBT()
                    this.$refs['gofixTable'].updateDeletedBT()
                });
            },

            /*-- Modal Data --------*/
            showModal() {
                this.getListSOR();
            },
            newItem() {
                this.modals.line.loadingModal = true
                this.modals.line.title = 'Add Line Items'
                this.modals.line.isNew = true
                this.modals.line.data.line_items.length = 0
                this.modals.line.sorOptions = Object.assign({}, {})
                for(let i = 0; i < 5; i++) {
                    this.modals.line.data.line_items.push({
                        sor: null,
                        quantity: null,
                    })
                    this.modals.line.sorOptions[`item_${i+1}`] = []
                }
                this.modals.line.open = true
            },
            addItem(index) {
                this.modals.line.data.line_items.splice(index, 0, Object.assign({}, {
                    sor: null,
                    quantity: null,
                }));
                this.modals.line.sorOptions[`item_${index+1}`] = []
                this.getListSOR()
            },
            delItem(index) {
                this.$delete(this.modals.line.data.line_items, index);
                this.$delete(this.modals.line.sorOptions, index);
            },
            rowClick(item) {
                if(
                    !this.is_supplier ||
                    (this.is_supplier && (this.Item.created_by != this.User.id || (this.Item.current_approval_level !== -1 && this.Item.current_approval_level !== null) || (this.Item.status != 'Draft' && this.Item.status != 'Pending Revision')))
                ) return
                this.modals.line.title = 'Edit Line Item'
                this.modals.line.isNew = false
                this.modals.line.data.line_items.length = 0
                this.modals.line.data.line_items.push({
                    id: item.id,
                    sor: item.sor_item,
                    quantity: item.quantity
                })
                this.modals.line.sorOptions[`item_1`] = []
                this.modals.line.open = true
            },

            /*-- Store Data --------*/
            async deleteItems(callback) {
                const {
                    ids,
                    filter,
                    resolve,
                    reject
                } = await callback();
                await this.$store.dispatch('LMUApprovalRequestController/deleteLineItems', {
                    ids: ids,
                    lmu_approval_request_id: this.$route.params.id
                })
                .then(response => {
                    this.getDefectItem()
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    resolve(this.$notificationV2('deleting', 'defect_report_item'))
                })
                .catch(err => {
                    reject();
                })
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(async () => {
                    let arrTmp = this.modals.line.data.line_items.filter(item => item.sor && item.quantity)
                    if(!arrTmp.length) {
                        return this.$alertNotification("Please add at least 1 line item.", "danger");
                    }

                    this.modals.line.loading = true;
                    let objeClone = {};

                    let api = this.modals.line.isNew ? 'createMultipleLineItem': 'updateLineItem'
                    let key = 'adding'
                    if(this.modals.line.isNew) {
                        let line_items = []
                        this.modals.line.data.line_items.forEach(item => {
                            if(item.sor && item.quantity) {
                                let sor_description = item.sor.description_one ;
                                if(item.sor.description_two)
                                sor_description += ` - <span class="color-red">${item.sor.description_two}</span>`
                                let index = line_items.findIndex(x => x.sor_item_id == item.sor.id);
                                if(index !== -1) {
                                    line_items[index].quantity = line_items[index].quantity + Number(item.quantity)
                                } else {
                                    line_items.push({
                                        sor_item_id: item.sor.id,
                                        sor_code: item.sor.sor_code,
                                        sor_description: sor_description,
                                        unit_price: item.sor.unit_price,
                                        quantity: Number(item.quantity),
                                    })
                                }
                            }
                        });
                        objeClone = {
                            lmu_approval_request_id: this.Item.id,
                            line_items: JSON.stringify(line_items)
                        }
                    } else {
                        key = 'editing'
                        this.modals.line.data.line_items.forEach(item => {
                            let sor_description = item.sor.description_one ;
                            if(item.sor.description_two)
                            sor_description += ` - <span class="color-red">${val.description_two}</span>`
                            objeClone = {
                                id: item.id,
                                lmu_approval_request_id: this.Item.id,
                                sor_item_id: item.sor.id,
                                sor_code: item.sor.sor_code,
                                sor_description: sor_description,
                                unit_price: item.sor.unit_price,
                                quantity: Number(item.quantity),
                            }
                        })
                    }

                    this.$store.dispatch(`LMUApprovalRequestController/${api}`, objeClone)
                    .then(async response => {
                        this.modals.line.loading = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.modals.line.open = false;
                        this.getDefectItem()
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(key, 'defect_report_item'));
                    })
                    .catch(err => {
                        this.modals.line.loading = false;
                        if(err.response && err.response.data.error && err.response.data.error.message  && err.response.data.error.message.error) {
                            this.$alertNotification(err.response.data.error.message.error, "danger"); 
                        }
                    })

                }, 200);
            }
        }
    }
</script>